class SliderControl {
	constructor () {
		this._value = 0.4;
		this._min = 30;
		this._max = 270;

		this._callback = null;
		this._endCallback = null;
		this._close = true;

		this.elem = div('slider-control', [
			div('slider-slot'),
			this._button = div('slider-button primary-color')
		]);

		this.initDrag = this.initDrag.bind(this);
		this.hide = this.hide.bind(this);
		onEv(this._button, 'mousedown touchstart', this.initDrag);
		onEv(this.elem, 'mousedown touchstart', () => {this._close = false;});
		onEv(document.body, 'mousedown touchstart', this.hide);
		document.body.appendChild(this.elem);
	}

	set value(v) {
		this._value = v;
		this.update();
	}

	show(elem, callback, endCallback) {
		this._callback = callback;
		this._endCallback = endCallback;
		let rect = elem.getBoundingClientRect();
		this.elem.style.top = rect.top + rect.height + 'px';
		this.elem.style.left = rect.left + (rect.width / 2) + 'px';
		this.elem.style.display = 'block';
		this._close = false;
		this.update();
	}

	hide(ev) {
		if (this._close) {
			this.elem.style.left = '-9999px';
			this._callback = null;
		}
		this._close = true;
	}

	initDrag(ev) {
		this._startX = this._button.offsetLeft + 10;
		startDrag(ev, this);
	}

	drag(ev) {
		this._value = limit((this._startX + dx - this._min) / (this._max - this._min), 0, 1);
		this.update();
		if (this._callback !== null) this._callback(this._value);
	}

	dropped() {
		if (this._endCallback !== null) this._endCallback();
	}

	update() {
		this._button.style.left = ((this._max - this._min) * this._value) + this._min + 'px';
	}

	dispose() {
		remEv(document.body, 'mousedown touchstart', this.hide);
		document.body.removeChild(this.elem);
	}
}